const en = {
  common: {
    popup: {
      titleConfirm: 'Are you sure to save these changes?',
    },
    message: {
      success: 'Successful!',
      assignDepartmentSuccess: 'Assign to department successfully',
    },
    error: {
      required: 'This is required field!',
      incorrectEmail: 'Incorrect email format!',
      passwordConfirm: 'Both password should be match',
      minValue: 'Must be at least 1',
      maxValuePassword: 'Must be at least 8 characters',
    },
    apiErrorMessages: {
      //- Common error message for each error code.
      errorCodeUnknown: 'Failed',
      errorCode1003a:
        'You can only upload documents with a maximum of {{remainPageCount}} pages per request',
      errorCode1003b:
        'You have reached the page limit allowed under your subscribed service plan. To continue using the service, please contact the administrator for assistance.',
      errorCode3000: 'Email address already exists in the system.',
      errorCode3002: 'Unable to remove this user.',
      errorCode7001: 'Primary column cannot be deleted.',
    },
  },
  menuBar: {
    documentTemplate: 'Document Templates',
    user: {
      uploadDocument: 'Upload Document',
      workFlow: 'WorkFlow',
      workFlowRequest: 'WorkFlow Requests',
      workFlows: 'WorkFlows',
      allDocument: 'All Documents',
      serviceHistory: 'Service History',
      support: 'Support',
    },
    admin: {
      invoice: 'Invoice',
      billing: 'Billing',
      usage: 'Usage',
      orgStructure: 'Dept. & Users',
      departments: 'Departments',
      users: 'Users',
      configuration: 'Configuration',
      logging: 'Audit Log',
      MBAL: 'MBAL',
      docsetMap: 'Docset Map',
      templateMap: 'Templates Map',
    },
  },
  header: {
    titleAccount: 'Account',
    titleLogOut: 'Logout',
    en: 'English (EN)',
    jp: 'Japanese (JP)',
    usage: {
      pageUsed: 'Pages used',
      thisMonth: 'this month',
    },
  },
  loginScreen: {
    title: 'Login',
    forgotPassword: 'Forgot password?',
    rememberMe: 'Remember me ?',
    loginUserNotFound: 'User does not exist, please contact admin',
    txtEmail: 'Email',
    txtPassword: 'Password',
    btnSignIn: 'Sign in',
    btnSignInWithMicrosoft: 'Sign in with Microsoft',
    error: {
      loginFail: 'Your email address or password is incorrect',
      passwordCurrent: 'Current password is not correct!',
      accountDeactivated:
        'Your account has been deactivated. Please contact the administrator for assistance',
    },
  },
  ChangePassWord: {
    currentPassword: 'Old Password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new passwords',
  },
  Placeholder: {
    email: 'Enter your email',
    password: 'Enter your password',
    forgotpass: 'Enter mail address',
    placeholderPassword: 'Password',
    inputConfirmPass: 'Confirm new password',
    inputNewPass: 'Enter new password',
    inputCurrentPass: 'Enter old password',
  },
  btnYes: 'Yes',
  btnNo: 'No',
  btnSend: 'Send',
  btnSave: 'Save',
  btnCancel: 'Cancel',
  btnApply: 'Search',
  btnExport: 'Export',
  btnReset: 'Reset',
  btnDownload: 'Download',
  btnReview: 'Review',
  btnView: 'View',
  btnDelete: 'Delete',
  btnDeactivate: 'Deactivated',
  btnSubmit: 'Submit',
  btnActive: 'Active',
  btnConfirm: 'Confirm',
  btnEdit: 'Edit',
  btnBack: 'Back',
  btnClose: 'Close',
  btnBacksignIn: 'Back to Sign-in',
  btnGenerateExcel: 'Generate Excel',
  btnClickUpload: 'Browse to upload',
  txtFormatPassword:
    '8 digits at least, case sensitive, non-alphanumeric symbol',
  txtCompanyInfo: 'General Information',
  txtBillinginformation: 'Billing information',
  txtDescription: 'Description',
  txtUpdateSettingSuccess: 'Update setting success',
  txtUpdateSettingFail: 'Update setting fail',
  txtBillDate: 'Bill Date',
  txtLastPaymentDate: 'Last Payment Date',
  txtClearFilter: 'Clear Filter',
  txtPagesPerBlock: 'Pages per Block',
  txtConfirm: 'Confirm',
  txtSearch: 'Search',
  txtCategory: 'Category',
  txtUpdateDate: 'Update Date',
  txtUploadDate: 'Uploaded time',
  txtOwner: 'Type',
  txtName: 'Name',
  txtTemplateList: 'Template List',
  txtPerPage: 'page',
  txtOf: 'of',
  txtItems: 'entries',
  txtDeleteTenant: 'Are you sure to delete Tenant',
  txtTitle: 'Title',
  txtRequestName: 'Request Name',
  placeholderRequestName: 'Enter Request Title',
  txtRequireUppercase: ' Capital letter(A-Z)',
  txtRequireLowercase: ' Lowercase letter(a-z)',
  txtRequireSpecialCharacter: ' Special characters( !@#$%^&*)',
  txtRequireNumber: ' Numbers(0-9)',
  txtHeadingValidate: 'Password must contain',
  txtDelete: 'Are you sure to permanently delete this item?',
  txtWarningDeleteMulti:
    'Are you sure you want to permanently delete all these items?',
  txtFotmatPhone: 'Please enter your phone number correctly',
  txtPassword: 'Incorrect password format',
  txtTotalPackageUsed: 'Total Package Used',
  txtTotalBlockUsed: 'Total Pages Used',
  txtTotalPageUsed: 'Total Page Used',
  txtDuplicate: 'Duplicate',
  txtDetail: 'Details',
  noSpace: 'All whitespace values ​​are not allowed',
  requiredFieldNumber: 'Please enter a maximum of 5 digits.',
  maxChar:
    'Document Template set name must not exceed 255 characters. Please shorten your text.',
  txtCreate: 'Are you sure you want to create this?',
  txtTotalTenants: 'Total Tenants',
  txtFromMonth: 'From month',
  txtToMonth: 'To month',
  txtMyProfile: 'Acount',
  txtAllTenant: 'All Tenants',
  txtEdit: 'Edit',
  txtAddTenant: 'Add Tenant',
  txtBilling: 'Billing',
  txtBillingDescription: 'This information is applied to all Tenants.',
  txtPages: '{{number}} per Page',
  txtPackageRegisteredCurrentMonth: 'Package Registered - Current Month',
  txtPackageRegisteredNextMonth: 'Package Registered - Next Month',
  txtBlockRegisteredCurrentMonth: 'Block Registered - Current Month',
  txtBlockRegisteredNextMonth: 'Block Registered - Next Month',
  txtCurrentValue: 'Current Value',
  txtNextValue: 'Current Value',
  txtNewValue: 'New Value',
  descriptionCurrentMonth:
    'New value will be applied for the current month. Please ensure that new value accurately reflects the desired changes. ',
  descriptionNextMonth:
    'New value will be applied for the next month onwards. Please ensure that new value accurately reflects the desired changes.',
  txtPackageRegistered: 'Package Registered',
  txtBlockRegistered: 'Block Registered',
  txtTotalPackageRegistered: 'Total Package Registered',
  txtCloseToLimit: 'Close to Limit',
  txtOutOfCredit: 'Full capacity',
  txtTotalBlockRegistered: 'Total Blocks Registered',
  txtBlocksPerPackage: 'Blocks per Package',
  txtConfirmPackageRegistered: 'Confirm Package Registered - Current Month',
  txtConfirmPackageRegisteredNext: 'Confirm Package Registered - Next Month',
  txtConfirmBlockRegistered: 'Confirm Block Registered - Current Month',
  txtConfirmBlockRegisteredNext: 'Confirm Block Registered - Next Month',
  txtFailFormat: 'Fail format',
  txtCurrentlyLimit:
    'Your request is currently exceeding limit! Please contact admin to adjust limit.',
  txtNofPage: 'No. of Pages',
  txtRemainingPageLimit: 'Remaining page limit',
  txtValuePackageRegistered: 'New value must be greater than current value!',
  txtGenerateExcelUsage: 'Generate Excel',
  txtAccessExpired:
    'This function is no longer available. Please contact Admin for assistance or renewal.',
  accessExpired: 'Access Expired',
  txtManyPage: 'Error! Too many pages detected.',
  txtCreateNewRequest: 'Create new request',
  txtGoOCRList: 'Go to OCR list',
  txtlimitExceed: 'Error! Limit exceeded, available page limit = ',
  txtWarning: 'Warning',
  uploadFileMax: 'Up to 10 files can be chosen per uploading',
  txtSent: 'Sent',
  txtDescriptionTemplate: 'Description',
  txtActionTemplate: 'Action',
  txtDescriptionToolTip:
    'Enter instructions here to guide the OCR in extracting values from the uploaded document in accordance to Field name you defines.',
  txtDescriptionToolTip1: 'Be specific and detailed.',
  txtForExample: 'For example:',
  txtForExample1: 'Field Name: Customer Name',
  txtForExample2:
    'Description: Customer name, the mentioned company at the bottom of document.',
  txtDescriptionToolTip3:
    'Remember that clear and precise instructions can improve the accuracy of the OCR results',
  Tenant: {
    searchTenant: 'Search',
    labelTenant: 'Tenant',
    labelStatus: 'Status',
    labelBlockLimit: 'Block Limit',
    labelMin: 'Min',
    labelMax: 'Max',
    labelOnboardDate: 'Onboard Date',
    txtSelectDate: 'Select date',
    deleteSuccess: 'Delete tenant success',
    deleteFail: 'Delete tenant fail',
    activeSuccess: 'Change status success',
    activeFail: 'Change status fail',
    btnAddTenant: 'Add Tenant',
    txtDetailTenant: 'Detail Tenant',
    updateTenantSuccess: 'Update Tenant Success',
    updateTenantFail: 'Update Tenant Fail',
    createTenantSuccess: 'Create Tenant Success',
    createTenantFail: 'Create Tenant Fail',
    labelUserInformation: 'User Information',
    labelGeneralInformation: 'General Information',
    labelSubscriptionInformation: 'Billing Information',
    getTenantSuccess: 'Get Tenant Success',
    getTenantFail: 'Get Tenant Fail',
    txtAction: 'Action',
  },
  Template: {
    txtTemplate: 'Document Template',
    txtDetailTemplate: 'Detail Template',
    templateName: 'Template Name',
    category: 'Category',
    description: 'Description',
    fieldSet: 'Field Set',
    standalone: 'Standalone',
    table: 'Table',
    create: 'Create',
    txtCreateTemplate: 'Create Template',
    txtEditTemplate: 'Edit Template',
    createTemplateSuccess: 'Create Template Success',
    createTemplateFail: 'Create Template Fail',
    txtDocuments: 'Documents',
    descriptionFile: 'Accepted format: PDF / JPEG / JPG / PNG',
    txtBtnUpload: 'Browse to upload',
    txtAddNewTemplate: 'Add New Template',
    txtStandalone: 'Standalone',
    txtTable: 'Table',
    txtAddRow: '+ Add data',
    txtAddColumn: '+ Add column',
    txtTableName: 'Table Name',
    txtTableDescription: 'Table Description',
    txtAddTable: '+ Add New Table',
    txtName: 'Name',
    txtDescriptionTemplate: 'Description',
    txtActionTemplate: 'Action',
    txtDuplicate: 'Duplicate',
    txtAssignTemplateToDepartments: 'Assign Template to Departments',
    txtTitleStaff: 'Staffs: ',
    txtTitleExpired: 'Expired: ',
    Table: {
      templateID: 'No. of Templates',
      createdDate: 'Created Date',
      txtDescription: 'Description',
      txtAction: 'Action',
      txtNameDocument: 'Uploaded Document',
      txtPage: 'Page',
      txtFormat: 'Format',
      txtUploadBy: 'Uploaded By',
    },
    error: {
      emptyName: 'Template name is required.',
      emptyCategory: 'Category is required.',
      emptyDescription: 'Description is required.',
      emptyFieldName: 'Field name is required.',
      emptyFieldDescription: 'Field description is required.',
      emptyTableName: 'Table name is required.',
      emptyTableDescription: 'Table description is required.',
      emptyTableFieldName: 'Table field name is required.',
      emptyTableFieldDescription: 'Table field description is required.',
      noFieldsOrTables: 'Please add at least one stand-alone field or a table.',
      noFieldsInTable: 'Please add at least one field to the table.',
    },
  },
  AddTenant: {
    emailAddress: 'Email Address',
    placeholderPassword:
      '8 digits at least, case sensitive, non-alphanumeric symbol',
    companyName: 'Company Name',
    placeholderCompanyName: 'Search is Company Name',
    placeholderEmailAddress: 'Enter email address',
    tenantDescriptions: 'Tenant Descriptions',
    placeholderTenantDescriptions: 'Enter Descriptions',
    inputCompanyName: 'Search is Company Name',
    inputAddress: 'Enter Address',
    contactEmail: 'Contact Email',
    placeholderContactEmail: 'Enter Contact email address',
    address: 'Address',
    placeholderAddress: 'Enter Address',
    contactName: 'Contact Name',
    placeholderContactName: 'Enter Contact name',
    phoneNumber: 'Phone number',
    placeholderPhoneNumber: 'Enter Phone number',
    blockLimit: 'Block Limit',
    placeholderBlockLimit: 'Eg. 10',
    expiredDate: 'Expired Date',
    tenantStatus: 'Tenant Status',
  },
  MessageError: {
    msgSentChangePasswordFail: 'Current password is incorrect',
    newPasswordSamePassOld: 'New password should not be same as old password',
    passwordSamePassOld: 'New password does not match!',
    passwordNotMatch: 'The passwords you just entered do not match',
    valiPassword:
      'Password must have at least 8 characters including lowercase letters, uppercase letters, numbers, and special characters!',
    msgUpdateProfileFail: 'Update profile fail',
    txtFail: 'Failed!',
    emailExistsTenant: 'Email address already exists in the system!',
    companyExist: 'Department Name already exists in the system!',
    cannotDeleteDepartment: 'Can not delete this department',
    cannotDeleteUser: 'Can not delete this user',
  },
  MessageSuccess: {
    msgUpdateProfileSuccess: 'Update profile success',
    passwordResetSuccess: 'Password is reset successfully!',
    confirmPaymentSuccess: 'Confirm payment success',
  },
  Status: {
    Usage: {
      all: 'All',
      normal: 'Normal',
      closeToLimit: 'Close to limit',
      fullCapacity: 'Full capacity',
    },
    Template: {
      all: 'All',
      custom: 'Custom',
      standard: 'Standard',
    },
    OCRList: {
      all: 'All',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
    },
    Tenant: {
      all: 'All',
      active: 'Active',
      deactivate: 'Deactivated',
    },
  },
  metaTitle: {
    login: 'Login',
    metadata: 'Metadata',
    verification: 'Verification',
    loginSSO: 'Login SSO',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    home: 'Home',
    account: 'Account',
    processingRequest: 'Processing Request',
    processingList: 'Processing List',
    processingReview: 'Processing Review',
    departments: 'Departments',
    departmentAdd: 'Add Department',
    departmentEdit: 'Edit Department',
    departmentDetail: 'Department Detail',
    departmentUsageDetail: 'Usage Details',
    users: 'Users',
    userAdd: 'Add User',
    userEdit: 'Edit User',
    userDetail: 'User Detail',
    usage: 'Usage',
    invoice: 'Invoice',
    invoiceDetail: 'Invoice Detail',
    documentTemplate: 'Document Templates',
    documentTemplateAdd: 'Add Document Template',
    documentTemplateEdit: 'Edit Document Template',
    documentTemplateDetail: 'Document Template Detail',
    serviceHistory: 'Service History',
    support: 'Support',
    page404: '404 Not Found',
    workFlow: 'Work Flow',
    requestWorkFlow: 'Request Work Flow',
    workFlows: 'Work Flows',
    logging: 'Audit Log',
    mbalDocsetMap: 'MBAL Docset Map',
    mbalTemplateMap: 'MBAL Template Map',
    confirmCancelJob: 'Do you want to cancel the data import process?',
    importing: 'Importing data...',
    importingActive: 'Data import in progress...',
    importSuccess: 'Data import successful',
    importFail: 'Data import failed',
  },
  requestScreen: {
    header: {
      title: 'Create Document Processing Request',
      titleBtnCancel: 'Cancel',
      titleBtnSubmit: 'Submit',
    },
    form: {
      titleLabel: 'Title',
      titlePlaceholder: 'Enter title',
      templateLabel: 'Template',
      templatePlaceholder: 'Select Document template',
      saveDocumentSetBtn: 'Save this Document Template Set',
      separatorDocument: 'Separate Document',
      ocr: 'IDP',
      workFlow: 'Work Flow',
      separatorTypeLabel: 'Separator Type',
      separatorValueLabel: 'Separator Value',
      separatorTitle: 'Separator',
      saveDocumentSuccess: 'Document Template set {{name}} saved.',
    },
    workflowSet: {
      workFlowTitle: 'Work Flow set',
      titleBtnCancel: 'Reset',
      titleBtnSubmit: 'Save',
      workFlowLabel: 'Work Flow Name',
      workFlowPlaceholder: 'Select Work Flow',
    },
    selection: {
      searchPlaceholder: 'Search',
      addTemplateBtn: 'Add Template',
      txtCreateTemplate: 'Create Template',
      templateTabTitle: 'Document Templates',
      documentSetTabTitle: 'Document Template Set',
    },
    popupSave: {
      title: 'Save Document Template set',
      label: 'Document Template Set Name',
      description: 'Description',
      placeholderDescription: 'Enter Document Template description',
      txtReset: 'Reset',
      txtCancel: 'Cancel',
      txtSubmit: 'Submit',
      txtSave: 'Save',
    },
    error: {
      txtFilesInvalid:
        'Files with invalid format or size detected: {{fileName}}',
    },
  },
  templateScreen: {
    header: {
      title: 'Document Templates',
      txtBreadcrumbAdd: 'add',
      txtBreadcrumbEdit: 'edit',
      txtCreateTemplate: 'Create Document Templates',
      txtEditTemplate: 'Edit Template',
    },
    tab: {
      template: 'Document Templates',
      documentSet: 'Document Template Set',
      txtBtnAddTemplate: 'Add Template',
      txtBtnCreateTemplate: 'Create Template',
      txtBtnAssignTo: 'Assign to..',
      txtBtnDelete: 'Delete',
      txtBtnAddDocumentSet: 'Add Template Set',
      txtBtnSyncTemplate: 'Sync',
      txtBtnImportTemplate: 'Import',
      txtBtnExportTemplate: 'Export ({{count}})',
    },
    formSearch: {
      searchLabel: 'Search by Template Name',
      categoryLabel: 'Category',
      createdByLabel: 'Created By',
      searchPlaceholder: 'Enter Template Name',
      categoryPlaceholder: 'All',
      createdByPlaceholder: 'All',
      searchTemplateLabel: 'Search by Template Id, Template Name, Category',
      searchTemplatePlaceholder: 'Enter Template Id, Template Name, Category',
    },
    detailScreen: {
      header: {
        title: 'Document Templates',
        txtBtnEdit: 'Edit Template',
      },
      info: {
        title: 'General Information',
        templateName: 'Template Name',
        category: 'Category',
        description: 'Description',
      },
      field: {
        title: 'Stand-alone Data',
        description: 'Standalone',
        fieldName: 'Name',
        fieldDescription: 'Description',
      },
      table: {
        title: 'Table ',
        nameCol: 'Name',
        descriptionCol: 'Description',
      },
    },
    listTemplate: {
      popupDocumentSet: {
        titleCreate: 'Create Document Template Set',
        titleEdit: 'Edit Document Template Set',
        txtAlert:
          'The document template set is created to help you quickly select templates when processing documents.',
        delete: {},
        field: {
          name: 'Document Template set name',
          namePlaceholder: 'Enter Document Template set name',
          description: 'Description',
          descriptionPlaceholder: 'Enter Description',
          listTemplate: 'Which Document templates will be included in the set?',
          selectTemplatePlaceholder: 'Select template',
        },
        txtBtnSave: 'Save',
        txtBtnCancel: 'Cancel',
        txtBtnSubmit: 'Submit',
      },
      tableTemplate: {
        id: 'ID',
        templateName: 'Template Name',
        category: 'Category',
        createdBy: 'Created By',
        createdTime: 'Created Time',
        lastUpdated: 'Last Updated',
        action: 'Action',
      },
      tableTemplateSet: {
        id: 'ID',
        templateSetName: 'Template Set Name',
        description: 'Description',
        noOfTemplate: 'No. of Templates',
        createdBy: 'Created By',
        createdTime: 'Created Time',
        lastUpdated: 'Last Updated',
        action: 'Action',
      },
      actionText: {
        view: 'View',
        assignTo: 'Assign to ..',
        edit: 'Edit',
        share: 'Share...',
        delete: 'Delete',
        duplicate: 'Duplicate',
      },
    },
    message: {
      create: {
        success: 'Create Document Template Set Success',
        error: 'Error Document Template Set',
      },
      edit: {
        success: 'Edit Document Template Set Success',
        error: 'Error Document Template Set',
      },
      error: {
        templateSelected: 'Please add at least 1 templates',
      },
    },
    popupConfirm: {
      title: 'Are you sure you want to cancel creating this template?',
    },
    popupDelete: {
      titleDocumentSet:
        'Are you sure to delete Document Set: {{templateName}}?',
      titleTemplate: 'Are you sure to delete template: {{templateName}}?',
      titleTemplateMultiple:
        'Are you sure you want to delete all the selected templates? This action cannot be undone.',
      titleSyncTemplate:
        'Do you want to synchronize and overwrite the old data?',
    },
    popupSyncTemplate: {
      title: 'Sync Template',
      system: 'System',
      templateTobeSync: 'Templates to be Synced',
      language: {
        en: 'Eng',
        jp: 'Japan',
        vn: 'Vietnam',
      },
      status: {
        new: 'New',
        updated: 'Update',
        notChanged: 'Not changed',
      },
      syncDate: 'Sync Date',
    },
    importTemplate: {
      title: 'Import document templates',
      dropFile: 'Drop a template bundle here or click to browse',
      fileHint: 'JSON template bundle, up to 2 MB and 100 templates',
      invalidFile: 'Please select a JSON template bundle',
      fileTooLarge: 'The template bundle must not exceed 2 MB',
      preview: 'Preview import',
      previewFailed: 'Could not preview the template bundle',
      previewSummary:
        '{{total}} templates: {{newCount}} new, {{conflict}} conflicts, {{unchanged}} unchanged',
      templateName: 'Template name',
      status: 'Status',
      action: 'Import action',
      statusLabel: {
        new: 'New',
        unchanged: 'Unchanged',
        conflict: 'Conflict',
        invalid: 'Invalid',
      },
      actionImport: 'Import',
      actionSkip: 'Skip',
      actionCopy: 'Create copy',
      actionOverwrite: 'Overwrite',
      confirmImport: 'Import templates',
      importFailed: 'Could not import templates',
      importSuccess:
        'Imported {{created}}, updated {{updated}}, copied {{copied}}, skipped {{skipped}} templates',
    },
  },
  processingScreen: {
    header: {
      title: 'All Documents',
      txtBtnGenerateExcel: 'Generate Excel',
      txtBtnCreateRequest: 'Create Request',
    },
    status: {
      all: 'All',
      sending: 'Sending',
      processing: 'Processing',
      extracting: 'Extracting',
      finished: 'Finished',
      failed: 'Failed',
      cancelling: 'Cancelling',
      cancelled: 'Cancelled',
    },
    formSearch: {
      searchLabel: 'Search by Request Name',
      searchPlaceholder: 'Enter Request Name',
      statusLabel: 'Status',
      dateRangeLabel: 'Date Range',
      statusPlaceholder: 'All',
      txtBtnSearch: 'Search',
      txtBtnClear: 'Clear',
    },
    list: {
      status: {
        sending: 'Sending',
        processing: 'Processing',
        extracting: 'Extracting',
        finished: 'Finished',
        failed: 'Failed',
        cancelled: 'Cancelled',
        cancelling: 'Cancelling',
      },
      table: {
        id: 'No.',
        requestName: 'Request Name',
        templateID: 'Template ID/ Document Set ID',
        noOfTemplate: 'No. of Templates',
        page: 'Pages',
        updateTime: 'Update Time',
        status: 'Status',
        action: 'Action',
        row: {
          templates: '{{numberTemplate}} templates',
        },
        uploadedDocument: 'Uploaded Document',
        uploadedTime: 'Uploaded time',
        confidenceScoreTitle: 'Confidence Score',
      },
      confirmCancel:
        'Are you sure you want to cancel this extraction request? This action cannot be undone.',
      cancelSuccess:
        'Cancellation completed. The request will not be processed.',
    },
    reviewScreen: {
      header: {
        title: 'Result: {{name}} (Request ID: {{requestId}})',
        titleBtn: 'Save & Export',
        dropDownBtn: {
          save: 'Save Result',
          export: 'Save & Export to Excel file',
        },
      },
      uploadReview: {
        uploaded: 'Uploaded',
        upload: 'Upload',
        readyToReview: 'Ready to review',
        processing: 'Processing',
        failed: 'Failed',
        documentNotFound: 'Document not found',
        loadingData: 'Loading data...',
        loadingDocument: 'Loading document...',
        cancel: 'Cancelling',
      },
      PDFViewer: {},
      ResultViewer: {
        title: 'Result',
        nameField: 'Name',
        valueField: 'Value',
        titleHeaderTable: 'Table ',
        template: 'Template',
        editTemplate: 'Edit Template',
        titleStand: 'Stand-alone',
        showConfident: 'Show Confidence Score',
        hideConfident: 'Hide Confidence Score',
        displayOption: 'Display Options',
        lowScore: 'Low Confidence Score',
        highScore: 'High Confidence Score',
        suggestedData: 'Suggested data',
        addRowBelow: 'Add row below',
        deleteRow: 'Delete row',
      },
      popupCancelConfirm: {
        title:
          'Are you sure you want to cancel? You have unsaved changes that will be reverted.',
      },
      popupConfirm: {
        title: 'Confirm',
        titleBtnCancel: 'Cancel',
        titleBtnOk: 'Ok',
      },
      contextMenu: {
        insertRowAbove: 'Insert Row Above',
        insertRowBelow: 'Insert Row Below',
        duplicateRowAbove: 'Duplicate Row Above',
        duplicateRowBelow: 'Duplicate Row Below',
        deleteRow: 'Delete Row',
      },
      toolbarPDF: {
        zoomOut: 'Zoom Out',
        zoomIn: 'Zoom In',
        pageFirst: 'Page First',
        pagePrevious: 'Previous Page',
        pageNext: 'Next Page',
        pageLast: 'Page Last',
        rotateLeft: 'Rotate Left',
        rotateRight: 'Rotate Right',
      },
    },
  },
  usageScreen: {
    header: {
      title: 'Usage Details',
      txtBtnExportExcel: 'Export to Excel',
    },
    formFiller: {
      searchLabel: 'Department Name',
      searchPlaceholder: 'Search by Department name',
      expiryDateLabel: 'Expiry Date',
      expiryPlaceholder: 'dd/mm/yyyy',
      statusLabel: 'Status',
      statusPlaceholder: 'All',
      txtBtnSearch: 'Search',
      txtBtnClear: 'Clear',
    },
    table: {
      departmentName: 'Department Name',
      departmentId: 'Department ID',
      onboard: 'Onboard',
      month: 'Month',
      regBlocks: 'Reg. Blocks',
      blockUsed: 'Block Used',
      pageUse: 'Page Used',
      noOfRequest: 'No. of Request',
      status: 'Status',
    },
  },
  departmentScreen: {
    header: {
      title: 'Departments',
      titleCreateDepartment: 'Create new Department',
      titleEditDepartment: 'Edit Department',
      titleDetail: 'Department Details',
      txtBtnNewDepartment: 'New Department',
      txtBtnEdit: 'Edit',
      txtBtnSave: 'Save',
      txtBtnCancel: 'Cancel',
      usageDetai: 'Usage Details',
    },
    formFilter: {
      searchLabel: 'Department Name',
      searchPlaceholder: 'Search by Department name',
      usageDepartmentSearchLabel: 'Department ID',
      usageDepartmentSearchPlaceholder: 'Department ID',
      usageUserSearchLabel: 'User ID',
      usageUserSearchPlaceholder: 'User ID',
      statusLabel: 'Status',
      statusPlaceholder: 'All',
      expiryDateLabel: 'Expiry Date',
      expiryDatePlaceholder: 'dd/mm/yyyy',
      fromMonthLabel: 'From Month',
      toMonthLabel: 'To Month',
      usageDetailDatePlaceholder: 'MM/YYYY',
      createdDateLabel: 'Created Date',
      status: {
        all: 'All',
        active: 'Active',
        deactivate: 'Deactivated',
      },
      txtBtnSearch: 'Search',
      txtBtnClear: 'Clear',
    },
    table: {
      No: 'ID',
      departmentName: 'Department Name',
      departmentId: 'Department ID',
      requestId: 'Request ID',
      noOfUsers: 'No. of Users',
      userId: 'User ID',
      userName: 'Staff Name',
      userEmail: 'User Email',
      pages: 'Pages',
      uploadedTime: 'Uploaded Time',
      blockCurrentMonth: 'Reg. Blocks Current Month',
      blockNextMonth: 'Reg. Blocks Next Month',
      createdDate: 'Created Date',
      expired: 'Expired',
      activate: 'Activate',
      action: 'Action',
      status: 'Status',
      blockLimit: 'Reg. Blocks',
    },
    formDepartment: {
      title: 'General Information',
      departmentNameLabel: 'Department Name',
      descriptionLabel: 'Description',
      departmentNamePlaceholder: 'Enter Department name',
      descriptionPlaceholder: 'Enter Department description',
      subscriptionDetails: 'Billing information',
      blockLimitLabel: 'Block Limit',
      blockLimitPlaceholder: 'Enter Block Limit',
      currentMonthLabel: 'Blocks Registered - Current Month',
      currentMonthPlaceholder: 'Enter No. of blocks registered',
      nextMonthLabel: 'Blocks Registered - Next Month',
      nextMonthPlaceholder: 'Enter No. of blocks registered',
      expiryDateLabel: 'Expiry Date',
      activateLabel: 'Department Status',
      templateListTitle: 'Template List',
      spanCardContent: 'ID: {{id}} - Category: {{category}}',
      spanCardTime: 'Created: {{created}} - Updated: {{updated}}',
      titleUserList: 'User List',
      titleTemplateList: 'Template List',
      titleMetadataList: 'Metadata List',
      titleWorkflowList: 'Workflow List',
      txtAlreadyAdded: 'ALREADY ADDED ({{number}})',
      txtNotAdded: 'NOT ADDED ({{number}})',
      formFilter: {
        searchLabelUserList: 'User Name or Email',
        searchPlaceholderUserList: 'Search by user name or email',
        statusLabel: 'Status',
        statusPlaceholder: 'All',
        createdDateLabel: 'Created Date',
        searchLabelTemplateList: 'Search by Name or Category',
        searchPlaceHolderTemplateList: 'Enter Template Name or Category',
        categoryLabel: 'Category',
        status: {
          all: 'All',
          active: 'Active',
          deactivate: 'Deactivated',
        },
        txtBtnSearch: 'Search',
        txtBtnClear: 'Clear',
        searchPlaceHolderMetadataList: 'Enter Table Name',
        searchPlaceHolderWorkflowList: 'Enter Workflow Name',
        searchLabelWorkflowList: 'Search by Name or Description',
      },
      table: {
        txtNo: 'No.',
        txtUserName: 'User Name',
        txtUserEmail: 'User Email',
        txtCreateDate: 'Create Date',
        txtStatus: 'Status',
        txtAction: 'Action',
        txtID: 'ID',
        txtTemplateName: 'Template Name',
        txtIndustry: 'Industry',
        txtCategory: 'Category',
        txtLanguage: 'Language',
        txtCreatedTime: 'Created Time',
        txtLastUpdate: 'Last update',
        txtCreatedAt: 'Created At',
        txtUpdatedAt: 'Updated At',
        txtWorkflowName: 'Name',
        txtDescription: 'Description',
      },
      txtBtnAssignTemplate: 'Assign Templates',
      txtWarning:
        'Search templates and select which templates you want to assign to the department.',
      txtBtnAssignWorkflow: 'Assign Workflow',
      txtWarningAssignWorkflow:
        'Search workflows and select which workflows you want to assign to the department.',
      txtBtnAssignTable: 'Assign Metadata',
      txtWarningAssignTable:
        'Search metadatas and select which metadatas you want to assign to the department.',
      txtBlockLimitEditHistory: 'Block Limit Edit History',
    },
    popupDelete: {
      titleDepartment: 'Are you sure to delete department: {{departmentName}}?',
    },
    error: {
      messageDepartmentNameExist: 'Department already exists in the system!',
      messageBlockLimit:
        'Unable to assign the department a number of blocks exceeding the registered block limit with BnK. Please adjust the allocation accordingly.',
    },
    blockLimitHistory: {
      title: 'Block Limit Edit History',
      modifyTime: 'Modification Time',
      oldBlockLimit: 'Old Block Limit',
      newBlockLimit: 'New Block Limit',
      modifier: 'Modifier',
    },
  },
  userScreen: {
    header: {
      title: 'Users',
      titleCreateUser: 'Create New User',
      titleEditUser: 'Edit User',
      txtBtnNewUser: 'New User',
      txtBtnSave: 'Save',
      userDetail: 'User Details',
    },
    formFilter: {
      searchLabel: 'User Name or Email',
      searchPlaceholder: 'Search by name or email',
      statusLabel: 'Status',
      departmentLabel: 'Department',
      createdDateLabel: 'Created Date',
      createdDatePlaceholder: 'dd/mm/yyyy',
      status: {
        all: 'All',
        active: 'Active',
        deactivate: 'Deactivated',
      },
      department: {
        all: 'All',
      },
      txtBtnSearch: 'Search',
      txtBtnClear: 'Clear',
    },
    table: {
      staffName: 'Staff Name',
      emailAddress: 'Email Address',
      department: 'Department',
      blockLimit: 'Block Limit',
      createdDate: 'Created Date',
      expiryDate: 'Expiry Date',
      activate: 'Status',
      action: 'Action',
    },
    status: {
      active: 'Active',
      deactivate: 'Deactivated',
    },
    formUser: {
      title: 'General Information',
      emailLabel: 'Email',
      passwordLabel: 'Password',
      staffNameLabel: 'Staff Name',
      departmentLabel: 'Department',
      phoneLabel: 'Phone No.',
      descriptionLabel: 'Description',
      emailPlaceholder: 'Enter user email',
      passwordPlaceholder: 'Enter password',
      staffNamePlaceholder: 'Enter staff name',
      departmentPlaceholder: 'Select department',
      phonePlaceholder: 'Enter phone number',
      descriptionPlaceholder: 'Enter description',
      subscriptionDetails: 'Subscription Details',
      blockLimitLabel: 'Block Limit',
      expiryDateLabel: 'Expiry Date',
      activateLabel: 'Status',
      blockLimitPlaceholder: 'Enter block limit',
    },
    popupDelete: {
      titleUser: 'Are you sure to delete user: {{userName}}?',
    },
  },
  activateScreen: {
    title: 'Create Admin Account',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    placeHolderEmail: 'Enter email',
    placeHolderConfirmPassword: 'Confirm password',
    placeHolderPassword: 'Enter password',
    txtBtnCreateAdmin: ' Create Admin Account',
    error: {
      message: 'Register fail',
      title: 'Token is invalid or expired.',
      goHome: 'Back to Home',
      passwordNotMatch: 'Confirm password does not match!',
    },
  },
  notFoundScreen: {
    titleNotFound: 'Sorry, the page you visited does not exist.',
    txtButtonBack: 'Back Home',
  },
  forgotPasswordScreen: {
    title: 'Forgot Password',
    btnBack: 'Back',
    forgotPasswordInstructions:
      'We’ll get this fixed in no time. Enter the email address you used to sign up, and we’ll send you a link to reset your password.',
    sendEmail: 'Send email',
    resendEmail: 'Resend Email',
    noticeEmailSuccess:
      'An Email has been sent to your address, please check your inbox and also spams.',
    error: {
      emailDoesNot: 'Email address does not exist!',
    },
  },
  resetPasswordScreen: {
    welcomeBack: 'Welcome back!',
    resetPasswordInstructions:
      'Please set a new password before continue logging in.',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    btnResetPassword: 'Reset Password',
    successfully: 'Successfully',
    yourPassWordHasBeenChanged: 'Your password has been changed',
    signIn: 'Sign In',
    invalidPassword: 'Invalid Password',
    error: {
      password:
        'Must have at least 8 characters, 1 uppercase letter (A-Z), 1 lowercase letter (a-z), 1 number (0-9), and 1 special character.',
    },
    success: {
      msgSentRequestSuccess:
        'Reset password link is sent to your email address. Please check your inbox (or spam folder) to reset your password.',
    },
    Placeholder: {
      Password: 'Enter your password',
      ConfirmPassword: 'Confirm your password',
    },
  },

  processingRequestScreen: {
    headerTitle: 'Document Processing - Let AI read files for you!',
    headerSubtitle: 'Convert PDF, image into text',
    uploadInstructions: 'Click or Drop PDF and image files here to upload',
    btnUpload: 'Choose files',
    acceptedFormats: 'Accepted format: PDF, JPEG, JPG, PNG',
    fileRestrictions: 'Max size: {{maxSize}}MB. Up to {{maxFiles}} files',
    btnSubmit: 'Process',
    btnDeleteFile: 'Delete all files',
    ProgressProcess: 'Processing document...',
    fileProcessingFailed: 'File Processing Failed',
    backToUpload: 'Back to Upload',
    retryProcessing: 'Retry Processing',
    failedToProcessFileName: 'Failed to process {{name}}',
    requestError: {
      unknownError:
        'An unknown error occurred. Please try again later. {{name}}',
      invalidTenantCode:
        'You do not have permission to access this request. {{name}}',
      overLimitPagePerRequest:
        'Your request exceeds the maximum page limit per request. {{name}}',
      invalidQuotaCode:
        'Quota has been exhausted. Please contact your administrator. {{name}}',
      tenantExpiredCode:
        'Your account has expired. Please contact your administrator. {{name}}',
      uploadFail: 'File upload failed. Please try again. {{name}}',
      notFound: 'The requested resource was not found. {{name}}',
      InvalidFileType:
        'Invalid file type. Please upload a valid file. {{name}}',
      tenantInactiveCode:
        'Your account is inactive. Please contact your administrator. {{name}}',
      partnerExpiredCode:
        'Your partner account has expired. Please contact your partner. {{name}}',
      partnerDeactive:
        'Your partner account is deactivated. Please contact your partner. {{name}}',
    },
    error: {
      messageFailRequest: 'Request fail',
      messageDepartmentDeactivated:
        'Department is deactivated, please contact your department',
      messagePageDetected:
        'Your uploaded document exceeds the page limit. The maximum allowed is 30 pages. Please reduce the number of pages and try again.',
      messageQuotaExceeded: 'Quota exceeded, please contact your department',
      messageDepartmentExpired:
        'Department is expired, please contact your department',
      messagePartnerDeactivated:
        'Partner is deactivated, please contact your partner',
    },
  },
  accountScreen: {
    title: 'My Account',
    txtBtnChangePassword: 'Change Password',
    form: {
      title: 'General Information',
      emailLabel: 'Email',
      staffNameLabel: 'Staff Name',
      departmentLabel: 'Department',
      phoneLabel: 'Phone No.',
      descriptionLabel: 'Description',
      subscriptionDetails: 'Subscription Details',
      blockLimitLabel: 'Block Limit',
      expiryDateLabel: 'Expiry Date',
    },
  },
  invoiceScreen: {
    groupInvoice: {
      totalBlockRegistered: 'Total Blocks Registered',
      totalAmount: 'Total Amount',
      payments: 'Payments',
      overdue: 'Overdue',
      pendingPayments: 'Pending Payments',
      overduePayments: 'Overdue Payments',
    },
    header: {
      title: 'Invoices',
      titleDetail: 'Invoice Detail',
      txtExportPayment: 'Export Payment',
    },
    status: {
      all: 'All',
      pending: 'Pending',
      paid: 'Paid',
      overdue: 'Overdue',
    },
    statusDetail: {
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
    },
    formFiller: {
      searchLabel: "Department's Name",
      searchPlaceholder: 'Search by Department name',
      monthLabel: 'Bill Month',
      monthPlaceholder: 'mm/yyyy',
      statusLabel: 'Status',
      statusPlaceholder: 'All',
      txtBtnSearch: 'Search',
      txtBtnClear: 'Clear',
    },
    table: {
      id: 'Invoice ID',
      departmentId: 'Department ID',
      departmentName: 'Department Name',
      tenantID: 'Tenant ID',
      tenantName: 'Tenant Name',
      billMonth: 'Bill Month',
      pageUsage: 'Page Usage',
      blockRegistered: 'Block Registered',
      totalAmount: 'Total Amount',
      unitPrice: 'Unit Price',
      paymentStatus: 'Payment Status',
      paymentDate: 'Payment Date',
      dueDate: 'Due Date',
      markAsPaid: 'Mark as Paid',
      action: 'Actions',
    },
    detail: {
      table: {
        id: 'ID',
        nameRequest: 'Request Name',
        status: 'Status',
        rate: 'Confidence Score',
        noOfPage: 'No. of Pages',
        uploadDate: 'Upload Date',
      },
    },
    error: {
      getInvoiceDetail: 'Get Invoice Detail Fail',
    },
    popupConfirm: {
      txtResetPayment: 'Are you sure to uncheck this item?',
      confirmPayment: 'Confirm Payment',
      confirmPaymentPlaceholder: 'dd/mm/yyyy',
      confirmPaymentSuccess: 'Confirm Payment Success',
      paymentDate: 'Payment Date',
      confirmPaymentFail: 'Confirm Payment Fail',
    },
    action: {
      view: 'View',
      exportPayment: 'Export Payment',
    },
  },
  workFlowScreen: {
    requestWorkFlow: {
      header: 'All WorkFlow Requests',
      txtBtnCreateWorkflowRequest: 'Create Workflow Request',
      table: {
        id: 'No.',
        name: 'Name',
        status: 'Status',
        action: 'Actions',
      },
      status: {
        waiting: 'Waiting',
        running: 'Running',
        finished: 'Finished',
        failed: 'Failed',
      },
    },
    workflowPopup: {
      create: {
        title: 'Create Workflow',
      },
      update: {
        title: 'Update Workflow',
      },
    },
    workFlows: {
      header: 'All WorkFlows',
      txtBtnCreateWorkflow: 'Create Workflow',
      txtBtnExportWorkflow: 'Export Workflow',
      table: {
        id: 'No.',
        name: 'Name',
        description: 'Description',
        action: 'Actions',
        updatedAt: 'Updated At',
        createdBy: 'Created By',
      },
      action: {
        edit: 'Edit',
        duplicate: 'Duplicate',
        delete: 'Delete',
        shareWithAdmin: 'Share With Admin',
      },
      modalDelete: {
        title: 'Are you sure to delete Flow: {{flowName}}?',
      },
      formFilter: {
        searchLabel: 'Workflow Name',
        searchPlaceholder: 'Search by Workflow name',
      },
      detail: {
        workflowName: 'Workflow Name',
        description: 'Description',
      },
      modalExport: {
        title: 'Export all files',
        subTitle: 'Do you want to retrieve all the local file workflow?',
      },
    },
    editWorkflow: {
      header: {
        title: 'Edit Workflow',
      },
    },
  },
  metadataScreen: {
    header: 'Metadata tables',
    table: {
      id: 'No.',
      name: 'Name',
      description: 'Description',
      action: 'Actions',
    },
    action: {
      edit: 'Edit',
      delete: 'Delete',
    },
    addBtn: 'Create Table',
    modalDelete: {
      title: 'Are you sure to delete table: {{tableName}}?',
    },
  },
  loggingScreen: {
    header: 'Audit Log',
    table: {
      id: 'No.',
      action: 'Action',
      user: 'User',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
    },
  },
  mbalScreen: {
    docsetMap: {
      header: 'Document Set Map',
      txtBtnCreateDocsetMap: 'Create Docset Map',
      table: {
        id: 'No.',
        documentSet: 'Document Set',
        claimType: 'Claim Type',
        documentType: 'Document Type',
        action: 'Action',
      },
      popup: {
        titleCreate: 'Create Document Set Map',
        titleEdit: 'Edit Document Set Map',
        titleDelete: 'Are you sure to delete this item?',
      },
    },
    templateMap: {
      header: 'Template Map',
      txtBtnCreateTemplateMap: 'Create Template Map',
      table: {
        id: 'No.',
        template: 'Template',
        subDocumentType: 'Sub Document Type',
        action: 'Action',
      },
      popup: {
        titleCreate: 'Create Template Map',
        titleEdit: 'Edit Template Map',
        titleDelete: 'Are you sure to delete this item?',
      },
    },
  },
};

export default en;
